'use client';

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/nextjs';

// App Router renders this in place of the root layout when a render throws, so
// it owns the <html>/<body> tags. Without it, React render errors in App Router
// routes (including the CMS catch-all) never reach Sentry.
const GlobalError = ({ error }) => {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        <h1>Something went wrong</h1>
        <p>
          We&apos;ve been notified and are looking into it. Please refresh the
          page or try again shortly.
        </p>
      </body>
    </html>
  );
};

GlobalError.propTypes = {
  error: PropTypes.object.isRequired,
};

export default GlobalError;
